import strings from 'rise-ui/config/strings.js';

export function keywordsForHelpTopic(topic) {
  return topic === 'topic2' ? strings['catalog-keywords']
    : topic === 'topic3' ? strings['time-series-keywords-main']
    : topic === 'topic4' ? strings['map-keywords']
    : topic === 'topic5' ? strings['visualizations-keywords']
    : topic === 'topic7' ? strings['faq-keywords']
    : topic === 'topic8' ? strings['api-keywords']
    : topic === 'topic9' ? strings['download-api-keywords']
    : strings['help-search-meta-description'];
}
